import type { OptionType } from '@omnipresentgroup/design-system';

export const PAYROLL_PROVIDER_STATUS_PARAM = 'status';

export const PAYROLL_PROVIDER_STATUS_OPTIONS: OptionType[] = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
].sort((a, b) => a.label.localeCompare(b.label));
